
import { TixxSelectSubmissionStatusTranslationsService } from '../../../shared/translations/customer/tixx-select-submission-status-translations.service';
import { DateObject } from '../reusables/date-object';
import { Currency } from '../reusables/currency';
import { Status } from '../reusables/status';

/**
 * Blueprint for the reminder entity.
 */
export class TixxSelectSubmission {
  public id: string;
  public submittedAt: DateObject;
  public publicLottery: any;
  public primaryTicketRequest: any;
  public secondaryTicketRequest: any;
  public priceDeviation: any;
  public contiguousSeating: any;
  public status: Status;
  public customer: any;
  public priority: Status;
  public statuses: Array<any> = [
    { value: 'received', status: this.statusTranslations.i18nReceivedStatus, class: 'esf-tag--info' },
    { value: 'normal', status: this.statusTranslations.i18nNormal, class: 'esf-tag--info' },
    { value: 'prioritized', status: this.statusTranslations.i18nPrioritized, class: 'esf-tag--success' },
    { value: 'deferred', status: this.statusTranslations.i18nDeferred, class: 'esf-tag--alert--red' },
    { value: 'drawn', status: this.statusTranslations.i18nDrawn, class: 'esf-tag--warning' },
    { value: 'successful', status: this.statusTranslations.i18nSuccessful, class: 'esf-tag--success' },
    { value: 'unsuccessful', status: this.statusTranslations.i18nUnsuccessful, class: 'esf-tag--alert--red' },
  ];

  public deviations: Array<any> = [
    { value: 'higher', status: this.statusTranslations.i18nHigher },
    { value: 'lower', status: this.statusTranslations.i18nLower },
    { value: 'both', status: this.statusTranslations.i18nHigherLower },
    { value: null, status: this.statusTranslations.i18nNo },
  ];

  public seating: Array<any> = [
    { value: true, status: this.statusTranslations.i18nNo },
    { value: false, status: this.statusTranslations.i18nYes },
  ];

  constructor(submissions: any, private statusTranslations: TixxSelectSubmissionStatusTranslationsService) {
    this.id = submissions.id;
    this.submittedAt = new DateObject(submissions.submittedAt, 'dd.MM.yyyy HH:mm');
    this.publicLottery = submissions.publicLottery;
    this.primaryTicketRequest = submissions.primaryTicketRequest ? new TicketRequest(submissions.primaryTicketRequest) : null;
    this.secondaryTicketRequest = submissions.secondaryTicketRequest ? new TicketRequest(submissions.secondaryTicketRequest) : null;
    this.priceDeviation = submissions.priceDeviation;
    this.contiguousSeating = submissions.contiguousSeating;
    this.customer = submissions.customer;
    this.status = this.getFullStatus(submissions.status);
    this.priority = this.getFullStatus(submissions.priority.name);
  }

  /**
   * Retrieves the status
   */
  public getFullStatus(status: string): any {
    const fullStatus = this.statuses.find(el => status === el.value);
    return fullStatus ? new Status(fullStatus) : status;
  }

  public get fullName(): string {
    if (!this.publicLottery.event.homeTeam || !this.publicLottery.event.guestTeam) {
      return this.publicLottery.event.name;
    }

    return `${this.publicLottery.event.name} | ${this.publicLottery.event.homeTeam} - ${this.publicLottery.event.guestTeam}`;
  }

  public get translatedDeviation(): string {
    const deviation = this.deviations.find(el => this.priceDeviation === el.value);
    return deviation.status ?? this.priceDeviation;
  }

  public get translatedContiguousSeating(): string {
    const seating = this.seating.find(el => this.contiguousSeating === el.value);
    return seating.status ?? this.contiguousSeating;
  }
}

export class TicketRequest {
  public id: string;
  public numbOfTickets: number;
  public tickets: Array<Ticket> = [];

  constructor(ticketRequest: any) {
    this.id = ticketRequest.id;
    this.numbOfTickets = ticketRequest.numbOfTickets;
    for (const ticket of ticketRequest.tickets) {
      this.tickets.push(new Ticket(ticket));
    }
  }
}

export class Ticket {
  public id: string;
  public ticketPersonalization: any;
  public priceCategoryAssignedReduction: any;
  public amount: Currency;

  constructor(ticket: any) {
    this.id = ticket.id;
    this.ticketPersonalization = ticket.ticketPersonalization;
    this.priceCategoryAssignedReduction = ticket.priceCategoryAssignedReduction;
    this.amount = new Currency(
      parseFloat((ticket.priceCategoryAssignedReduction.reducedAmount / 100).toString()).toFixed(2),
      ticket.priceCategoryAssignedReduction.currencyCode
    );
  }

  public get fullAmount(): string {
    return `${this.amount.value} ${this.amount.currency}`;
  }
}
